'use strict';
angular.module('resourceCenterXJRBModule').controller('XJRBQuickPreviewCtrl', [
    '$scope',
    '$q',
    '$state',
    '$stateParams',
    '$sce',
    '$filter',
    'resCtrModalService',
    'globleParamsSet',
    'initComDataService',
    'trsHttpService',
    'resourceCenterService',
    'trsspliceString',
    '$interval',
    '$compile',
    '$timeout',
    'storageListenerService',
    'stockApiService',
    'stockService',
    function(
        $scope,
        $q,
        $state,
        $stateParams,
        $sce,
        $filter,
        resCtrModalService,
        globleParamsSet,
        initComDataService,
        trsHttpService,
        resourceCenterService,
        trsspliceString,
        $interval,
        $compile,
        $timeout,
        storageListenerService,
        stockApiService,
        stockService
    ) {
        initStatus();
        initData();

        /**
         * [initStatus 初始化页面状态]
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: globleParamsSet.setResourceCenterPageSize,
            };
            $scope.data = {
                casDataArea: [], //  地区的级联数组
                items: [], //  列表数据
                pic: [], //  微博的图片数据
                previewItems: [], //  数字报版面数据
                headers: [], //  列表头部
                selectedArray: [], //  复选框所选数据
                operFlags: [], //  取签见撤重
                suggestResult: '', //  搜索匹配结果
                suggestContentList: [], //  搜索匹配的内容列表
                rebuildData: {}, //  传递给右侧详情的信息
                tenantId: '', // 当前环境新疆日报租户ID
                curMediaId: '', // 当前媒体ID
                curChanelName: stockService.getSourceName($stateParams.fcode),
            };
            $scope.status = {
                channelType: $stateParams.fcode, //  栏目类型
                screenWrapSelected: false, //  是否显示更多筛选
                singleGraph: false, //  是否为单图模式
                hasphoto: false, //  是否显示图集
                showRightDetail: true, //  是否显示右侧详情
                curSelected: '', //  当前选中的详情ID
                fcode: $stateParams.fcode,
            };
            $scope.basicParams = {
                channelName: 'jtcpg',
                typeName: 'jt_lyzh',
                nodeId: $stateParams.fcode,
            };
            $scope.listParams = stockApiService.getDocListParams();
            $scope.data.keyword = $scope.listParams.keyword;
            $scope.tenanIdParams = stockApiService.getGongGaoTenantIdParam();
            quickPreviewFix();
        }

        /**
         * [quickPreviewFix 快速预览修正]
         *
         * @return  {[type]}  [return description]
         */
        function quickPreviewFix() {
            if ($state.params.fcode === 'wb') {
                var routerName = $state.current.name.replace(/quickpreview/, 'resource');
                $state.go(routerName, $state.params, { reload: routerName });
            }
        }

        /**
         * [initData 初始化页面数据]
         *
         * @return  {[type]}  [return description]
         */
        function initData() {
            if ($scope.basicParams.nodeId) {
                listenStorage();
                initDropDown()
                    .then(function() {
                        return initTenantId();
                    })
                    .then(function(){
                        return initProducts();
                    })
                    .then(function() {
                        if ($scope.$root && angular.isDefined($scope.$root.filterData)) {
                            // 判断是否有传递的数据
                            dealFilterData();
                        } else {
                            requestData();
                        }
                        $scope.$on('$destroy', function() {
                            // 销毁对象
                            delete $scope.$root.filterData;
                        });
                    });
            }
        }

        /**
         * [dealFilterData 处理筛选条件]
         *
         * @return  {[type]}  [return description]
         */
        function dealFilterData(){
            $scope.page = $scope.$root.filterData.page;
            $scope.data.fromdate = $scope.$root.filterData.fromdate;
            $scope.data.untildate = $scope.$root.filterData.untildate;
            $scope.data.keyword = $scope.$root.filterData.paramsKeyword;
            $scope.listParams.pageNum = $scope.page.CURRPAGE;
            $scope.listParams.pageSize = $scope.page.PAGESIZE;
            $scope.docType = $scope.$root.filterData.docType; // 当前稿件类型
            $scope.themeType = $scope.$root.filterData.themeType; // 当前主题
            $scope.keyType = $scope.$root.filterData.keyType; // 当前检索信息
            // 默认展开更多筛选项
            if (
                $scope.data.keyword.isHead == '1' ||
                $scope.docType.curValue.value != '' ||
                $scope.themeType.curValue.id != '' ||
                $scope.data.keyword.isOriginal == '1' ||
                $scope.data.keyword.isRead == '1' ||
                $scope.$root.filterData.area != undefined
            ) {
                $scope.status.screenShow = true;
            }
            // 默认展开检索信息
            if ($scope.data.keyword.keywords != '' || $scope.data.keyword.searchType != 0) {
                $scope.status.searchShow = true;
            }
            if ($scope.$root.filterData.area) {
                $scope.data.casDataArea.push($scope.$root.filterData.area[0]);
            }
            if ($scope.$root.filterData.listData) {
                // 是否图集稿，是则直接传递图集列表数据
                $scope.status.hasphoto = true;
                $scope.data.items = $scope.$root.filterData.listData;
                $scope.status.singleGraph = $scope.$root.filterData.singleGraph; // 是否单图
                storageListenerService.previewPageTurningStorage($scope.data.items, 'ZB_GUID', 'resourceDetail');
                if ($scope.data.items.length > 0) {
                    showDetail($scope.data.items[0]);
                }
                getFilterDataBack();
            } else {
                requestData();
            }
        }

        /**
         * [initTenantId 获取供稿租户ID（当前环境的新疆日报租户ID）]
         *
         * @return  {[type]}  [return description]
         */
        function initTenantId() {
            let defer = $q.defer();
            stockApiService.getGongGaoTenantId($scope.tenanIdParams).then((data) => {
                $scope.data.tenantId = data;
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [initProducts 初始化栏目信息]
         *
         * @return  {[type]}  [return description]
         */
        function initProducts(){
            let defer = $q.defer();
            let productParam = stockApiService.getProductParams();
            productParam.fcode = $scope.status.fcode;
            productParam.tenantId = $scope.data.tenantId.replace(/\"/g, '');
            stockApiService.getProduct(productParam).then(function(productData){
                $scope.product = {
                    data: [{ name: '所有' + $scope.data.curChanelName, media_id: '' }].concat(productData.content),
                    curValue: { name: '所有' + $scope.data.curChanelName, media_id: '' },
                };
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [getListByMedia 获取某个产品下的文章列表]
         *
         * @param   {[type]}  mediaId  [mediaId description]
         *
         * @return  {[type]}           [return description]
         */
        $scope.getListByMedia = function(mediaId){
            // eslint-disable-next-line camelcase
            $scope.data.curMediaId = mediaId;
            requestData();
        };

        /**
         * [listenStorage description]监听本地缓存
         * @return {[promise]} [description] promise
         */
        function listenStorage() {
            storageListenerService.listenResource(function() {
                requestData();
                storageListenerService.removeListener('resource');
            }, $scope);
        }

        /**
         * [initDropDown description] 下拉框初始化
         * @return {[type]} [description]
         */
        function initDropDown() {
            var defer = $q.defer();
            // 全部稿件
            $scope.docType = {
                data: initComDataService.newsType(),
                curValue: initComDataService.newsType()[0],
            };
            // 检索字段
            $scope.keyType = {
                data: initComDataService.searchBigdataType(),
                curValue: initComDataService.searchBigdataType()[0],
            };
            // 所有主题
            let themeParams = stockApiService.getThemeTypeParams();
            stockApiService.getThemeType(themeParams).then(function(themeData) {
                $scope.themeType = {
                    data: [{ dictName: '所有主题', id: '' }].concat(themeData),
                    curValue: { dictName: '所有主题', id: '' },
                };
                defer.resolve();
            });
            return defer.promise;
        }
        
        /**
         * [showSelectedArea description] 数据地域信息的级联菜单获取数据
         * @param  {[type]} node [description] 当前节点
         * @return {[type]}      [description]
         */
        $scope.showSelectedArea = function(node) {
            var deffer = $q.defer();
            resourceCenterService.getArea(node).then(function (data) {
                deffer.resolve(data);
            });
            return deffer.promise;
        };
       
        /**
         * [requestData description]test数据请求
         * @return {[type]} [description]
         */
        function requestData() {
            dealListParam().then(function(params) {
                $scope.loadingPromise = stockApiService.getDocList(params).then(function(data) {
                    dealData(data);
                });
            });
        }

        /**
         * [dealData 处理列表数据]
         *
         * @param   {[type]}  data  [data description]
         *
         * @return  {[type]}        [return description]
         */
        function dealData(data) {
            $scope.data.headers = data.summary_info.hybaseField;
            $scope.data.indexName = data.summary_info.indexName;
            if ($scope.status.channelType === 'szb' && data.content.length > 0) {
                // 数字报：处理版名版次
                // dealWithBMBC($scope.data.headers);
            }
            $scope.page = data.summary_info;
            if (!$scope.status.hasphoto) {
                // 普通稿
                $scope.data.items = data.content;
                initOperFlag();
                findReprintCounts();
            } else {
                // 图集稿
                data.content = $scope.data.items.concat(data.content);
                $scope.data.items = data.content;
            }
            storageListenerService.previewPageTurningStorage($scope.data.items, 'ZB_GUID', 'resourceDetail');
            if ($state.params.guid) {
                showDetail({ ZB_GUID: $state.params.guid });
            } else if ($scope.data.items.length > 0) {
                showDetail($scope.data.items[0]);
            }
            getFilterDataBack();
        }

        /**
         * [dealListParamForWCM 从大数据获取新疆日报成品稿件数据前处理参数]
         *
         * @return  {[type]}  [return description]
         */
        function dealListParam() {
            let deffer = $q.defer();
            var params = angular.extend({}, $scope.listParams);
            params.fcode = $scope.status.fcode;
            params.pageSize = $scope.page.PAGESIZE;
            params.pageNum = $scope.page.CURRPAGE;
            // eslint-disable-next-line camelcase
            params.media_id = $scope.data.curMediaId;
            params.keyword = JSON.stringify($scope.data.keyword);
            if ($scope.data.tenantId !== '') {
                params.tenantId = $scope.data.tenantId;
                // params.tenantId = 54; // 测试环境调用正式环境数据测试用
                deffer.resolve(params);
            } else {
                stockApiService.getGongGaoTenantId($scope.tenanIdParams).then(function(tenantId) {
                    params.tenantId = tenantId;
                    // params.tenantId = 54; // 测试环境调用正式环境数据测试用
                    deffer.resolve(params);
                });
            }

            return deffer.promise;
        }
       
        /**
         * [loadMore description] 图集-加载更多
         * @return {[type]} [description]
         */
        $scope.loadMore = function() {
            $scope.listParams.pageNum++;
            requestData();
        };

        /**
         * [findReprintCounts description] 获取转载量
         * @return {[type]} [description]
         */
        function findReprintCounts() {
            stockService.findReprintCounts($scope.data.items).then((data) => {
                $scope.data.items = data;
            });
        }

        /**
         * [pageChanged description] 分页
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            $scope.listParams.pageNum = $scope.page.CURRPAGE;
            delete $state.params.guid; // 分页跳转时不需要从路由上获取数据
            requestData();
        };
        
        /**
         * [initOperFlag description] 初始化取签见撤重
         * @return {[type]} [description]
         */
        function initOperFlag() {
            stockService.initOperFlag($scope.status.fcode, $scope.data.items).then(function(data){
                $scope.data.operFlags = data;
            });
            $scope.data.selectedArray = [];
        }

        /**
         * [viewBigDataInfo 取签见撤重]
         *
         * @param   {[type]}  ChnlDocId   [ChnlDocId description]
         * @param   {[type]}  showRepeat  [showRepeat description]
         * @param   {[type]}  showClick   [showClick description]
         *
         * @return  {[type]}              [return description]
         */
        $scope.viewBigDataInfo = function(ChnlDocId, showRepeat, showClick) {
            var operFlags = stockService.queryItemBYGUID(ChnlDocId, $scope.data.operFlags).OPERFLAG;
            var infoModal = resCtrModalService.bigDataInfoModal(ChnlDocId, showRepeat, showClick, operFlags);
            event.stopPropagation();
        };

        /**
         * [showOperFlag description] 显示取签见撤重标志
         * @param  {[type]} guid      [description] 稿件id
         * @param  {[type]} flagIndex [description] 类型
         * @return {[type]}           [description]
         */
        $scope.showOperFlag = function(guid, flagIndex) {
            var temp = stockService.queryItemBYGUID(guid, $scope.data.operFlags);
            if (!!temp) {
                return stockService.queryItemBYGUID(guid, $scope.data.operFlags).OPERFLAG.substr(flagIndex, 1) === '1';
            } else {
                return false;
            }
        };

        /**
         * [isShowSearch description]显示隐藏检索条件
         * @return {Boolean} [description]
         */
        $scope.isShowSearch = function() {
            $scope.status.searchShow = !$scope.status.searchShow;
            // 隐藏清空？
            //
        };
        
        /**
         * [getFilterTimeVal description]检索下拉框回调
         * @return {[type]} [description]
         */
        $scope.getFilterVal = function() {
            $scope.data.keyword.searchType = $scope.keyType.curValue.value;
        };

        /**
         * [fullTextSearch 全文检索]
         *
         * @param   {[type]}  ev  [ev description]
         *
         * @return  {[type]}      [return description]
         */
        $scope.fullTextSearch = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode === 13) || angular.isUndefined(ev)) {
                $scope.page.CURRPAGE = '1';
                delete $state.params.guid; // 全文检索时不需要从路由上获取数据
                requestData();
            }
        };

        /**
         * [showScreen description] 显示隐藏更多筛选
         * @return {[type]} [description]
         */
        $scope.showScreen = function() {
            $scope.status.screenShow = !$scope.status.screenShow;
        };

        /**
         * [searchWithKeyword description] 根据条件筛选稿件
         * @param  {[type]} key   [description] 筛选类型
         * @param  {[type]} value [description] 筛选内容
         * @return {[type]}       [description]
         */
        $scope.searchWithKeyword = function(key, value) {
            if (key == 'time') {
                value = $filter('date')($scope.data.fromdate, 'yyyy/MM/dd').toString()
                    ? $filter('date')($scope.data.fromdate, 'yyyy/MM/dd').toString() +
                      ',' +
                      $filter('date')($scope.data.untildate, 'yyyy/MM/dd').toString()
                    : '';
            } else if (key == 'area') {
                value = value[0][value.length - 1].id;
            }
            $scope.data.keyword[key] = value;
            if (key == 'menuscriptType' && value != '2') {
                $scope.status.hasphoto = false;
            } else if (key == 'menuscriptType' && value == '2') {
                $scope.status.hasphoto = true;
            }
            $scope.data.keyword.searchType = $scope.keyType.curValue.value;
            $scope.listParams.pageNum = $scope.page.CURRPAGE = 1;
            $scope.data.items = [];
            delete $state.params.guid; // 不需要从路由上获取数据
            requestData();
        };

        /**
         * [singleGraphMode description] 是否为单图模式
         * @return {[type]} [description]
         */
        $scope.singleGraphMode = function() {
            $scope.status.singleGraph = !$scope.status.singleGraph;
            delete $state.params.guid; // 不需要从路由上获取数据
            requestData();
        };

        /**
         * [getFilterDataBack description]获取跳转回普通视图存储信息
         * @return {[type]} [description]
         */
        function getFilterDataBack() {
            if($scope.$root){
                $scope.$root.filterDataBack = {
                    page: $scope.page, // 分页
                    fromdate: $scope.data.fromdate, // 开始时间
                    untildate: $scope.data.untildate, // 结束时间
                    paramsKeyword: $scope.data.keyword, // 其他条件
                    area: $scope.data.area, // 地域信息
                    docType: $scope.docType, // 当前稿件类型
                    themeType: $scope.themeType, // 当前主题
                    keyType: $scope.keyType, // 当前检索信息
                };
                if ($scope.status.hasphoto) {
                    // 是否图集稿，是则直接传递图集列表数据
                    $scope.$root.filterDataBack.listData = $scope.data.items;
                    $scope.$root.filterDataBack.singleGraph = $scope.status.singleGraph; // 是否单图
                }
            }
        }

        /**
         * [fullTextSearch description;全文检索]
         * @param  {[type]} ev [description:按下回车也能提交]
         */
        $scope.fullTextSearch = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                $scope.page.CURRPAGE = '1';
                delete $state.params.guid; // 全文检索时不需要从路由上获取数据
                requestData();
            }
        };

        /**
         * [showDetail description]展示详情
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.showDetail = function(item) {
            showDetail(item);
        };

        /**
         * [showDetail description] 展示详情
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        function showDetail(item) {
            $scope.status.showRightDetail = false;
            $state.params.guid = item.ZB_GUID;
            $state.go($state.current.name, $state.params, { reload: false });
            $scope.data.rebuildData = {
                guid: item.ZB_GUID,
            };
            $timeout(function() {
                $scope.status.curSelected = item.ZB_GUID;
                $scope.status.showRightDetail = true;
            });
        }

        /**
         * [plainView description] 普通视图
         * @return {[type]} [description]
         */
        $scope.plainView = function() {
            $state.go('front.resourcectrl.xjrb.resource', $stateParams);
        };
    },
]);
